"use client"

import { getFixedT } from "@/languages/i18n"
import { TransformedStoreItem } from "../types"

interface StoreListProps {
    stores: TransformedStoreItem[]
    selectedStoreId: number | null
    onStoreClick: (store: TransformedStoreItem) => void
    locale?: string
}

const StoreList = ({ stores, selectedStoreId, onStoreClick, locale }: StoreListProps) => {
    const t = getFixedT(locale)
    return (
        <div className="w-full sm:w-[27.5%] flex flex-col bg-white relative z-0 sm:z-0">
            {/* Header */}
            <div className="bg-[#242F3E] text-white py-[12.5px] pl-6">
                <h2 className="sm:text-xl sm:leading-[31px] text-[10px] leading-[15.5px] font-bold uppercase">{t("FIND US ON MAP")}</h2>
            </div>

            {/* Store List */}
            <div className="sm:border-l border-[#00000033] border overflow-y-auto flex-1">
                {stores.map((store) => {
                    const isSelected = store.id === selectedStoreId
                    return (
                        <div key={store.id}>
                            <button
                                onClick={() => onStoreClick(store)}
                                className={`w-full text-left border-b border-[#00000033] sm:pt-[23px] sm:pb-5 sm:pr-[36px] sm:pl-[25px] py-5 px-2.5 ${isSelected
                                    ? "bg-[#18af4e] text-white"
                                    : "bg-white text-[#333]"
                                    }`}
                            >
                                <div className="font-bold sm:text-sm sm:leading-[21.7px] text-xs leading-[18.6px]">{store.name}</div>
                                <div className={`sm:block hidden text-sm leading-[21.7px] ${isSelected ? "text-white" : "text-[#333]"}`}>
                                    {store.address}
                                </div>
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default StoreList
